import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Stack,
  Grid2,
} from "@mui/material";
import { Iconify } from "../Minimal/src/components/iconify";
import { Link, useParams } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import { API_URL } from '../Config';
import config from "../common/Config";
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const PurchaseHistoryViewPrint = (props) => {
  const { orderId } = useParams();

  const [productData, setProductData] = useState([]);
  const [shopDetails, setShopDetails] = useState([]);
  const [commonData, setCommonData] = useState([]);
  const [totalVal, setTotalVal] = useState({
    grandTotal: 0,
  });

  const accessToken = localStorage.getItem('accessToken');
  const company_tax_type = localStorage.getItem("company_tax_type");
  const currencySymbol = localStorage.getItem("currencySymbol");

  const formatNumber = (num) => {
    return parseFloat(num).toFixed(2);
  };

  const fetchProductInfo = async () => {
    const formData = new FormData();
    formData.append('id', orderId);
    const apiUrl = `${API_URL}/purchases/grn_view_details`;
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to fetch Not Order Report');
      }
      const data = await response.json();
      setCommonData(data.grn_details.grn_details[0]);
      setShopDetails(data.grn_details.shop_details);
      setProductData(data.grn_details.grn_items);

      const grandTotal = data.grn_details.grn_items.reduce((acc, item) => {
        const quantity = parseFloat(item.quantity);
        const unitCost = item.type === '1' ? parseFloat(item.unit_cost) : parseFloat(item.piece_cost);
        const tax = (unitCost * quantity) * parseFloat(item.rate) / 100;
        const stotal = unitCost * quantity;
        const pdtTotal = stotal + tax;
        return acc + pdtTotal;
      }, 0);

      setTotalVal({ grandTotal: formatNumber(grandTotal) });
    } catch (error) {
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    fetchProductInfo();
  }, [accessToken]);

  /* const generatePDF = () => {
     const doc = new jsPDF();
     doc.text('Purchase History', 14, 20);
 
     const tableData = productData.map((item) => {
       const quantity = parseFloat(item.quantity);
       const unitCost = item.type === '1' ? parseFloat(item.unit_cost) : parseFloat(item.piece_cost);
       const tax = (unitCost * quantity) * parseFloat(item.rate) / 100;
       const stotal = unitCost * quantity;
       const pdtTotal = stotal + tax;
       return [
         item.product_code + ' - ' + item.product_name,
         item.quantity,
         item.type === '1' ? 'Box' : 'Piece',
         `£ ${formatNumber(unitCost)}`,
         `£ ${formatNumber(tax)}`,
         `£ ${formatNumber(pdtTotal)}`,
       ];
     });
 
     doc.autoTable({
       head: [
         ['Description', 'Quantity', 'Type', 'Unit Cost', 'Tax', 'Subtotal'],
       ],
       body: tableData,
       startY: 30,
       theme: 'grid',
     });
 
     doc.text(`Total: £ ${totalVal.grandTotal}`, 14, doc.lastAutoTable.finalY + 10);
     doc.save(`PurchaseHistory_${orderId}.pdf`);
   };*/

  const generatePDF = () => {
    const doc = new jsPDF();

    // Header
    const header = [
      [`Order Summary for ${shopDetails.shop_name}`, `Order Date: ${commonData.reference_no}`],
      [`Order : INV${commonData.po_id}`, `Supplier Name: ${commonData.name}`],
    ];

    // Define columns for autoTable
    const columns = [
      { title: 'Description', dataKey: 'description' },
      { title: 'Quantity', dataKey: 'quantity' },
      { title: 'Unit Cost', dataKey: 'unit_cost' },
      { title: `${company_tax_type}`, dataKey: 'tax' },
      { title: 'Subtotal', dataKey: 'subtotal' },
    ];

    // Prepare data for the table
    const tableData = productData.map(item => ({
      description: `${item.product_code} - ${item.product_name}`,
      quantity: parseFloat(item.quantity, 10),
      unit_cost: `${currencySymbol} ${formatNumber(item.unit_cost)}`,
      tax: `${currencySymbol} ${formatNumber(item.tax)}`,
      subtotal: `${currencySymbol} ${formatNumber(item.total)}`
    }));

    // Add header to the document
    doc.autoTable({
      head: header,
      startY: 10,
      headStyles: { fontSize: 10, textColor: '#666', fillColor: '#eee' },
      margin: { top: 20 },
      showHead: 'firstPage',
    });

    // Add table body
    const itemsPerPage = 20;
    const totalPages = Math.ceil(tableData.length / itemsPerPage);

    for (let i = 0; i < totalPages; i++) {
      const startIndex = i * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const pageData = tableData.slice(startIndex, endIndex);

      if (i > 0) {
        doc.addPage();
      }

      doc.autoTable({
        columns: columns,
        body: pageData,
        startY: doc.previousAutoTable.finalY + 10 || 20,
        styles: { fontSize: 10 },
      });

      // Add footer only on the last page
      if (i === totalPages - 1) {
        const endY = doc.previousAutoTable.finalY;
        doc.autoTable({
          startY: endY + 10,
          body: [[`Total : £ ${totalVal.grandTotal}`]],
          styles: { fontSize: 10, halign: 'right' },
        });
      }
    }

    // Save the PDF
    doc.save(`invoice_${commonData.supplierId}.pdf`);
  };

  return (
    <>
        <Box className="page-container">
          <Paper className="paper-style">
            <Box sx={{ px: 2, py:1.2}}>
              <Grid2 container spacing={3}>
                <Grid2 size={{ xs: 12, md: 4 }}>
                  <Box>
                    <Typography variant="h6" sx={{fontWeight: 600, color: "#212b36"}}>
                      {commonData.name || ""}
                    </Typography>
                    {commonData.note && (
                      <Typography variant="body2" sx={{color: "#637381", fontSize: "0.825rem" }}>
                        {commonData.note}
                      </Typography>
                    )}
                  </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 4 }}>
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: "#212b36", fontSize: "9rem" }}>
                      {shopDetails.shop_name || ""}
                    </Typography>
                    {shopDetails.address && (
                      <Typography variant="body2" sx={{ color: "#637381", fontSize: "0.825rem" }}>
                        {shopDetails.address}
                      </Typography>
                    )}
                  </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 4 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: "#212b36", fontSize: "9rem" }}>
                      Reference : {commonData.reference_no || ""}
                    </Typography>
                  </Box>
                </Grid2>
              </Grid2>
              </Box>
              <TableContainer>
                <Table size="medium" className="table-cell-border" sx={{ tableLayout: "fixed" }}>
                  <TableHead>
                    <TableRow className="table-cell-header">
                      <TableCell
                        sx={{
                          width: "40%",
                        }}
                      >
                        Description
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "10%",
                          textAlign: "center",
                        }}
                      >
                        Quantity
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "10%",
                          textAlign: "center",
                        }}
                      >
                        Type
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "10%",
                          textAlign: "right",
                        }}
                      >
                        Unit Cost
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "10%",
                          textAlign: "right",
                        }}
                      >
                        {company_tax_type}
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "10%",
                          textAlign: "right",
                        }}
                      >
                        Subtotal
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {productData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={6} sx={{ textAlign: "center", py: 3, color: "#637381" }}>
                          No products available
                        </TableCell>
                      </TableRow>
                    ) : (
                      productData.map((row, index) => {
                        const quantity = parseFloat(row.quantity);
                        const unitCost = row.type === '1' ? parseFloat(row.unit_cost) : parseFloat(row.piece_cost);
                        const tax = (unitCost * quantity) * parseFloat(row.rate) / 100;
                        const stotal = unitCost * quantity;
                        const pdtTotal = stotal + tax;

                        return (
                          <TableRow
                            key={index}
                            className="table-cell-style"
                            sx={{
                       
                              "&:last-child td": {
                                borderBottom: "none",
                              },
                          
                            }}
                          >
                            <TableCell
                            >
                              {row.product_code} - {row.product_name}
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: "center",
                              }}
                            >
                              {parseInt(row.quantity)}
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: "center",
                              }}
                            >
                              {row.type === '1' ? 'Box' : 'Piece'}
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: "right",
                              }}
                            >
                              {currencySymbol} {formatNumber(unitCost)}
                            </TableCell>
                            <TableCell
                              sx={{
                       
                                textAlign: "right",
                              }}
                            >
                              {currencySymbol} {formatNumber(tax)}
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: "right",
                              }}
                            >
                              {currencySymbol} {formatNumber(pdtTotal)}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        sx={{
                          textAlign: "right",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          color: "#212b36",
                          py: 1,
                          borderBottom: "none",
                        }}
                      >
                        Grand Total
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "right",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          color: "#212b36",
                          py: 1,
                          borderBottom: "none",
                        }}
                      >
                        {currencySymbol} {totalVal.grandTotal || "0.00"}
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
          </Paper>
        </Box>
    </>
  );
};

export default PurchaseHistoryViewPrint;
